export default "__VITE_ASSET__BHNyKbdr__"